<template>
  <b-container class="mt-5">
    <h4 class="mb-3">Article List</h4>

    <!-- Filter Bar -->
    <b-row class="mb-3 align-items-center">
      <b-col cols="12" md="6" lg="4">
        <b-input-group size="sm">
          <b-form-input
            v-model="searchTerm"
            placeholder="Search articles..."
            aria-label="Search articles"
          />
          <b-input-group-append>
            <b-input-group-text>
              <i class="fa fa-search"></i>
            </b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-col>

      <b-col cols="12" md="6" lg="4" class="mt-2 mt-md-0">
        <multiselect
          v-model="selectedValues"
          :options="categoryOptions"
          :multiple="true"
          :searchable="true"
          placeholder="Filter by Category"
          label="text"
          track-by="value"
          class="custom-multiselect"
        />
      </b-col>
    </b-row>

    <!-- Article Grid -->
    <b-row class="article-grid">
      <b-col
        v-for="article in paginatedArticles"
        :key="article.id"
        cols="12"
        sm="6"
        lg="4"
        class="d-flex"
      >
        <b-card
          :title="article.title"
          :img-src="getImgUrl(article.image)"
          img-alt="Image"
          img-top
          class="small-card flex-fill"
        >
          <div>
            <p>{{ new Date(article.created).toLocaleDateString() }}</p>
            <b-card-text class="text-muted article-excerpt">
            {{ stripHtml(article.content) }}
            </b-card-text>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-3">
            <b-badge variant="info" class="category-badge">
              {{ article.category.name }}
            </b-badge>
            <b-button size="sm" variant="success" @click="viewArticle(article)">
              Read More
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Pagination -->
    <b-row>
      <b-col class="d-flex justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="filteredArticles.length"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-3"
        />
      </b-col>
    </b-row>

    <!-- No results -->
    <div v-if="filteredArticles.length === 0" class="text-center text-muted mt-4">
      No articles found.
    </div>

    <!-- 🟢 Modal Detail -->
    <b-modal
      v-if="selectedArticle"
      id="article-detail-modal"
      v-model="showModal"
      size="lg"
      :title="selectedArticle.title"
      hide-footer
      :body-class="'bg-white'"      
      :content-class="'bg-white'"
    >
      <div v-if="selectedArticle">
        <div class="article-detail">
          <img
            v-if="getImgUrl(selectedArticle.image)"
            :src="getImgUrl(selectedArticle.image)"
            :alt="selectedArticle.title"
            class="detail-img mb-3"
          />
          <!-- konten lainnya -->
        </div>
        <p>{{ new Date(selectedArticle.created).toLocaleDateString() }}</p>
        <p class="text-muted mb-2"><b-badge variant="info">{{ selectedArticle.category.name }}</b-badge></p>
        <p class="article-content" v-html="selectedArticle.content"></p>
        <!-- <h6 class="mt-3">
          <a 
            :href="getImgUrl(selectedArticle.attachment)" 
            target="_blank" 
            rel="noopener noreferrer" 
            class="ml-2"
          >
            <b class="mr-2">Attachment Link</b>
            <i class="fa fa-file-pdf-o"></i>
          </a>
        </h6> -->
        <!-- PDF Preview -->
        <div v-if="selectedArticle.attachment">
          <embed :src="urlPdf" type="application/pdf" width="100%" height="600px" />
        </div>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import Multiselect from "vue-multiselect";
import { APIPATH_BBIAPPS } from "@/api/api-paths";
import { fnGET, fnPOST, fnGETCore } from "@/api/api-methods";
import { APIUrl } from "../../api/api-base";
export default {
  components: { Multiselect },
  data() {
    return {
      searchTerm: "",
      selectedValues: [],
      currentPage: 1,
      perPage: 6,
      categoryOptions: [],
      articles: [],
      showModal: false,
      selectedArticle: null,
      urlPdf:null
    };
  },
  computed: {
    filteredArticles() {
      const term = this.searchTerm.toLowerCase();
      const selectedCats = this.selectedValues.map((c) => c.value);
      return this.articles.filter((a) => {
        const matchesSearch =
          a.title.toLowerCase().includes(term) ||
          a.content.toLowerCase().includes(term);
        const matchesCategory =
          selectedCats.length === 0 || selectedCats.includes(a.category.name);
        return matchesSearch && matchesCategory;
      });
    },
    paginatedArticles() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredArticles.slice(start, start + this.perPage);
    },
  },
  watch: {
    searchTerm() {
      this.currentPage = 1;
    },
    selectedValues() {
      this.currentPage = 1;
    },
    selectedArticle(newData,oldData){
      if(newData){
        let dataUrl = this.getImgUrl(newData.attachment)
        this.getPdf(dataUrl)
      }
    }
  },
  mounted(){
    this.getDataArticle();
  },
  methods: {
    viewArticle(article) {
      this.selectedArticle = article;
      this.showModal = true;
    },
    getDataArticle() {
      this.isLoading = true;
      fnGETCore(APIPATH_BBIAPPS.article)
        .then((response) => {
          this.articles = response.data
          this.getDataArticleCat();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = true;
          console.log("error_log", error);
        });
    },
    getDataArticleCat() {
      this.isLoading = true;
      fnGETCore(APIPATH_BBIAPPS.article_cat)
        .then((response) => {
          this.categoryOptions = response.data.map((i)=>({value:i.name,text:i.name}));
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = true;
          console.log("error_log", error);
        });
    },
    stripHtml(html) {
        if (!html) return ''
        const text = html.replace(/<[^>]+>/g, '')
        const max = 90
        return text.length > max ? text.substring(0, max) + '...' : text
    },
    getImgUrl(url){
      return APIUrl + url
    },
    getPdf(url){
      fetch(url)
        .then(res => res.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          this.urlPdf =  url
        });
    }
  }
};
</script>

<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

/* ✅ Grid agar tetap rapi meski data 1–2 */
.article-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
}

/* ✅ Card styling */
.small-card {
  font-size: 0.9rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.small-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
}

.small-card .card-img-top {
  max-height: 180px;
  object-fit: cover;
}

.article-excerpt {
  max-height: 3.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.category-badge {
  font-size: 0.75rem;
  padding: 0.3em 0.5em;
  border-radius: 12px;
}

.custom-multiselect {
  font-size: 0.85rem;
}

/* ✅ pastikan card selalu sama tinggi */
.d-flex > .b-card {
  height: 100%;
}

.detail-img {
  width: 100%;         /* full width ke container */
  max-height: 100%;   /* batas tinggi, sesuaikan */
  object-fit: cover;    /* agar gambar memenuhi area dan bagian berlebih dipotong */
}

/* Kalau kamu mau show seluruh gambar tanpa crop, gunakan object-fit: contain */
.detail-img.contain {
  object-fit: contain;
}
</style>
